var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "editor-task-wrapper" }, [
    _vm.loading
      ? _c("div", { staticClass: "loading-overlay" }, [
          _c("div", { staticClass: "modern-loader" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("p", { staticClass: "loading-text" }, [
              _vm._v(_vm._s(_vm.$t("auto.loading"))),
            ]),
          ]),
        ])
      : _c("div", { attrs: { id: "Editor-task" } }, [
          _c("div", { staticClass: "editor-task" }, [
            _c("div", { staticClass: "editor-task-content" }, [
              _vm.currentWorkflow
                ? _c(
                    "div",
                    { staticClass: "status-switcher-wrapper" },
                    [
                      _c("TaskStatusBar", {
                        attrs: {
                          "status-list": _vm.pipelineStages,
                          "current-status": _vm.currentStage.name,
                        },
                        on: { "update-status": _vm.handleStageChange },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input title-input" },
                [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("task.title"))),
                  ]),
                  _vm._v(" "),
                  _c("a-input", {
                    staticClass: "classic-new-input",
                    attrs: { placeholder: _vm.$t("task.taskNumber") },
                    model: {
                      value: _vm.form.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "title", $$v)
                      },
                      expression: "form.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "editor-task-quill-editor" },
                [
                  _c("quill-editor", {
                    staticClass: "quill-editor",
                    staticStyle: { "max-height": "20%", width: "100%" },
                    attrs: {
                      options: _vm.editorOption,
                      placeholder: _vm.$t("task.createTaskDesc"),
                    },
                    model: {
                      value: _vm.form.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "description", $$v)
                      },
                      expression: "form.description",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "editor-task-new-checklist" }, [
                _c("div", { staticClass: "checklist-data" }, [
                  _vm.form.checklist.length > 0
                    ? _c(
                        "div",
                        { staticClass: "checklist-header" },
                        [
                          _c("span", { staticClass: "checklist-title" }, [
                            _vm._v(_vm._s(_vm.$t("auto.checklist"))),
                          ]),
                          _vm._v(" "),
                          _c("a-progress", {
                            staticClass: "checklist-progress",
                            attrs: {
                              "stroke-color": {
                                "0%": "#ec4b1d",
                                "100%": "#ec4b1d",
                              },
                              percent:
                                (100 / _vm.form.checklist.length) *
                                _vm.form.checklist.filter(function (c) {
                                  return c.isCompleted
                                }).length,
                              "show-info": false,
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "checklist-status" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t("task.completedOfCheck", {
                                    total: _vm.form.checklist.length,
                                    completed: _vm.form.checklist.filter(
                                      function (c) {
                                        return c.isCompleted
                                      }
                                    ).length,
                                  })
                                ) +
                                "\n                            "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.checklist.length > 0
                    ? _c(
                        "div",
                        { staticClass: "checklist-container mt-2" },
                        _vm._l(_vm.form.checklist, function (checkbox, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "checklist-row" },
                            [
                              _c(
                                "div",
                                { staticClass: "checklist-column" },
                                [
                                  _c("a-checkbox", {
                                    staticClass: "kanban-checkbox large",
                                    model: {
                                      value: checkbox.isCompleted,
                                      callback: function ($$v) {
                                        _vm.$set(checkbox, "isCompleted", $$v)
                                      },
                                      expression: "checkbox.isCompleted",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "checklist-column" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: checkbox.title,
                                      expression: "checkbox.title",
                                    },
                                  ],
                                  staticClass: "checklist-input",
                                  domProps: { value: checkbox.title },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        checkbox,
                                        "title",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "checklist-column action" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-icons delete-icon",
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteCheckbox(index)
                                        },
                                      },
                                    },
                                    [_vm._v("close")]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "checklist-button",
                      on: { click: _vm.addNewCheckBox },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            !_vm.form.checklist.length
                              ? _vm.$t("task.newCheckList")
                              : _vm.$t("task.add")
                          ) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "attachments-section" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "editor-task-attach-files",
                      on: { click: _vm.openFileInput },
                    },
                    [
                      _c("div", { staticClass: "attach-files" }, [
                        _c("div", { staticClass: "text" }, [
                          _c("div", { staticClass: "material-icons" }, [
                            _vm._v("attachment"),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("task.attachFiles"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "logo" }, [_c("s3Logo")], 1),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        staticStyle: { display: "none" },
                        attrs: { id: "fileInput", type: "file" },
                        on: { change: _vm.uploadFile },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.attachmentsUploading
                    ? _c(
                        "div",
                        { staticClass: "attachments-loading-overlay" },
                        [
                          _c(
                            "div",
                            { staticClass: "attachments-loading-content" },
                            [
                              _c("div", { staticClass: "attachments-spinner" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("auto.uploadingFile"))),
                              ]),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "row attachments-row",
                      staticStyle: { display: "grid", gap: "20px" },
                    },
                    _vm._l(_vm.form.attachments, function (attachment) {
                      return _c(
                        "div",
                        {
                          key: attachment._id,
                          staticClass: "attach-files-visibility",
                          staticStyle: { cursor: "pointer" },
                          on: {
                            click: function ($event) {
                              return _vm.openAttachment(attachment)
                            },
                          },
                        },
                        [
                          ["png", "jpeg", "jpg"].includes(attachment.ext)
                            ? [
                                _c("img", {
                                  attrs: {
                                    src:
                                      attachment.v2Format && attachment.cdnUrl
                                        ? attachment.cdnUrl
                                        : "https://static.supsis.live/" +
                                          (attachment.path + attachment._id) +
                                          "." +
                                          attachment.ext,
                                    alt: attachment.name,
                                  },
                                }),
                              ]
                            : [_vm._m(1, true)],
                          _vm._v(" "),
                          _c("div", { staticClass: "image-content" }, [
                            _c("div", { staticClass: "text" }, [
                              _vm.editImageName === attachment._id
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "edit-img-name",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                        },
                                      },
                                    },
                                    [
                                      _c("a-input", {
                                        attrs: { type: "text" },
                                        model: {
                                          value: attachment.name,
                                          callback: function ($$v) {
                                            _vm.$set(attachment, "name", $$v)
                                          },
                                          expression: "attachment.name",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("label", [
                                    _vm._v(_vm._s(attachment.name)),
                                  ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "description" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.updatedAtFormated(attachment.updatedAt)
                                  ) +
                                  "\n                                    "
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "edit-btn",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "underline",
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteAttachment(
                                            attachment._id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(_vm.$t("chatbotv2.delete")) +
                                          "\n                                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                                        |\n                                        "
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "underline",
                                      on: {
                                        click: function ($event) {
                                          return _vm.editImageNameFunc(
                                            attachment._id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(_vm.$t("message.edit")) +
                                          "\n                                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                                        |\n                                        "
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "underline",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openImage(attachment._id)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(_vm.$t("task.view")) +
                                          "\n                                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                                        |\n                                        "
                                  ),
                                  ["png", "jpeg", "jpg"].includes(
                                    attachment.ext
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "underline",
                                          on: {
                                            click: function ($event) {
                                              _vm.form.coverPhoto ===
                                              attachment._id
                                                ? _vm.removeCoverPhoto()
                                                : _vm.setCoverPhoto(
                                                    attachment._id
                                                  )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.form.coverPhoto ===
                                                  attachment._id
                                                  ? _vm.$t(
                                                      "message.coverPhotoRemove"
                                                    )
                                                  : _vm.$t(
                                                      "message.coverPhotoSet"
                                                    )
                                              ) +
                                              "\n                                        "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]),
                          ]),
                        ],
                        2
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("ChatMediaGallery", {
                    attrs: {
                      visible: _vm.taskGalleryVisible,
                      items: _vm.taskGalleryItems,
                      "initial-index": _vm.taskGalleryIndex,
                    },
                    on: {
                      "update:visible": function ($event) {
                        _vm.taskGalleryVisible = $event
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "add-tags ml-2 mt-4" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "10px",
                      color: "#ec4b1d",
                      "font-weight": "bold",
                      cursor: "pointer",
                      display: "flex",
                      "align-items": "center",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.addTag")) +
                        "\n                        "
                    ),
                    _c(
                      "a-dropdown",
                      [
                        _c(
                          "a-button",
                          {
                            staticStyle: {
                              "margin-left": "10px",
                              padding: "2px",
                            },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("add"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-menu",
                          { attrs: { slot: "overlay" }, slot: "overlay" },
                          _vm._l(_vm.tags, function (tag) {
                            return _c(
                              "a-menu-item",
                              {
                                key: tag._id,
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectTag(tag)
                                  },
                                },
                              },
                              [
                                _c("div", {
                                  staticClass: "showColor",
                                  style: {
                                    backgroundColor: tag.color,
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "5px",
                                    marginRight: "8px",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(tag.name))]),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.form.tags.length > 0
                  ? _c(
                      "div",
                      { staticClass: "selected-tags" },
                      _vm._l(_vm.form.tags, function (tag) {
                        return _c(
                          "div",
                          {
                            key: tag._id,
                            staticClass: "tag-item",
                            style: _vm.getTagStyle(tag.color),
                          },
                          [
                            _c("span", [_vm._v(_vm._s(tag.name))]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "material-icons close-icon",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeTag(tag._id)
                                  },
                                },
                              },
                              [_vm._v("close")]
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "editor-task-new-subtask ml-4" }, [
                _c("div", { staticClass: "row gap-10" }, [
                  _c(
                    "div",
                    {
                      staticClass: "subtask-button",
                      on: {
                        click: function ($event) {
                          return _vm.addNewSubtask(false)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("task.addSubtask")) +
                          "\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.form.subTasks.length > 0
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "10px",
                            display: "flex",
                            gap: "10px",
                            "flex-direction": "column",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "subtask-container" },
                            [
                              _c("div", { staticClass: "subtask-header" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("task.subtaskTitle"))),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("task.assignee"))),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.form.subTasks,
                                function (subtask, index) {
                                  return _c(
                                    "div",
                                    { key: index, staticClass: "subtask-row" },
                                    [
                                      !subtask.isExits
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "subtask-column" },
                                              [
                                                _c("a-checkbox", {
                                                  staticClass:
                                                    "kanban-checkbox large",
                                                  model: {
                                                    value: subtask.completed,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        subtask,
                                                        "completed",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "subtask.completed",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("a-input", {
                                                  staticClass:
                                                    "classic-new-input",
                                                  attrs: {
                                                    placeholder:
                                                      _vm.$t(
                                                        "task.subtaskTitle"
                                                      ),
                                                  },
                                                  model: {
                                                    value: subtask.title,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        subtask,
                                                        "title",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "subtask.title",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "subtask-column" },
                                              [
                                                _c("a-select", {
                                                  staticClass:
                                                    "select-multiple",
                                                  attrs: {
                                                    options:
                                                      _vm.visibilityUsers,
                                                    placeholder:
                                                      _vm.$t("task.assignee"),
                                                  },
                                                  model: {
                                                    value: subtask.assignees,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        subtask,
                                                        "assignees",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "subtask.assignees",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        : [
                                            _c(
                                              "div",
                                              { staticClass: "subtask-column" },
                                              [
                                                _c("a-select", {
                                                  staticClass:
                                                    "select-multiple",
                                                  attrs: {
                                                    options:
                                                      _vm.visibilityUsers,
                                                    placeholder:
                                                      _vm.$t("task.assignee"),
                                                  },
                                                  model: {
                                                    value: subtask.taskId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        subtask,
                                                        "taskId",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "subtask.taskId",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "subtask-column action",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "material-icons delete-icon",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteSubtask(
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("close")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tab-menu-container" }, [
                _c(
                  "div",
                  { staticClass: "tab-header" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "tab-button",
                        class: { active: _vm.activeTab === "comments" },
                        on: {
                          click: function ($event) {
                            _vm.activeTab = "comments"
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("task.comments")) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "tab-button",
                        class: { active: _vm.activeTab === "activities" },
                        on: {
                          click: function ($event) {
                            _vm.activeTab = "activities"
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("auto.activities")) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.form.doneStatus && _vm.form.doneStatus.length > 0
                      ? _c(
                          "button",
                          {
                            staticClass: "tab-button",
                            class: { active: _vm.activeTab === "doneStatus" },
                            on: {
                              click: function ($event) {
                                _vm.activeTab = "doneStatus"
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("task.closureStatusesTab")) +
                                "\n                        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.taskDetailWebTabs, function (webTab) {
                      return _c(
                        "button",
                        {
                          key: webTab._id,
                          staticClass: "tab-button webtab-button",
                          class: {
                            active: _vm.activeTab === "webtab-" + webTab._id,
                          },
                          on: {
                            click: function ($event) {
                              _vm.activeTab = "webtab-" + webTab._id
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "material-icons tab-icon",
                              style: { color: webTab.iconColor },
                            },
                            [_vm._v(_vm._s(webTab.icon))]
                          ),
                          _vm._v(
                            "\n                            " +
                              _vm._s(webTab.name) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tab-content" },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.activeTab === "comments",
                            expression: "activeTab === 'comments'",
                          },
                        ],
                        staticClass: "comments-section",
                      },
                      [
                        _c("CreateComment", {
                          attrs: { "task-id": _vm.details.taskId },
                        }),
                        _vm._v(" "),
                        _vm.commentsReady
                          ? _c("listComment", {
                              attrs: { "task-id": _vm.details.taskId },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.activeTab === "activities",
                            expression: "activeTab === 'activities'",
                          },
                        ],
                        staticClass: "activities-section",
                      },
                      [
                        _c("ActivtyTask", {
                          ref: "activtyTask",
                          attrs: { "task-id": _vm.details.taskId },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.activeTab === "doneStatus",
                            expression: "activeTab === 'doneStatus'",
                          },
                        ],
                        staticClass: "done-status-section",
                      },
                      _vm._l(_vm.form.doneStatus, function (status, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "done-status-card" },
                          [
                            _c("div", { staticClass: "done-status-header" }, [
                              _c("div", { staticClass: "status-info" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "material-icons",
                                    class: _vm.getStatusIcon(status.status),
                                  },
                                  [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(
                                          _vm.getStatusIconName(status.status)
                                        ) +
                                        "\n                                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "status-text" }, [
                                  _vm._v(_vm._s(status.status)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "status-date" }, [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(_vm.formatDate(status.date)) +
                                    "\n                                    "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "done-status-content" }, [
                              _c(
                                "div",
                                { staticClass: "user-info" },
                                [
                                  _c("Avatar", {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          followCursor: true,
                                          placement: "bottom-end",
                                        },
                                        expression:
                                          "{\n                                                followCursor: true,\n                                                placement: 'bottom-end',\n                                            }",
                                      },
                                    ],
                                    key: 1,
                                    attrs: {
                                      size: 25,
                                      src: status.actor.gravatar,
                                      username: status.actor.name,
                                      content: status.actor.email,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "user-name" }, [
                                    _vm._v(_vm._s(status.actor.name)),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "status-description" }, [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(status.description) +
                                    "\n                                    "
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.taskDetailWebTabs, function (webTab) {
                      return _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.activeTab === "webtab-" + webTab._id,
                              expression:
                                "activeTab === `webtab-${webTab._id}`",
                            },
                          ],
                          key: "content-" + webTab._id,
                          staticClass: "webtab-section",
                        },
                        [
                          _c("WebTabViewer", {
                            attrs: {
                              "web-tab-prop": webTab,
                              context: _vm.form,
                              "context-type": "task",
                              embedded: "",
                            },
                          }),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "editor-info task-sidebar-modern" }, [
            _c("div", { staticClass: "task-sidebar-scroll" }, [
              _c("div", { staticClass: "task-section" }, [
                _c(
                  "div",
                  { staticClass: "task-field" },
                  [
                    _c("label", { staticClass: "task-label" }, [
                      _vm._v(_vm._s(_vm.$t("message.startDate"))),
                    ]),
                    _vm._v(" "),
                    _c("a-date-picker", {
                      staticClass: "task-input",
                      attrs: {
                        suffixIcon: null,
                        dropdownClassName: "task-date-picker",
                        "show-time": "",
                      },
                      model: {
                        value: _vm.form.startDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "startDate", $$v)
                        },
                        expression: "form.startDate",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "task-field" },
                  [
                    _c("label", { staticClass: "task-label" }, [
                      _vm._v(_vm._s(_vm.$t("message.endDate"))),
                    ]),
                    _vm._v(" "),
                    _c("a-date-picker", {
                      staticClass: "task-input",
                      attrs: {
                        suffixIcon: null,
                        dropdownClassName: "task-date-picker",
                        "show-time": "",
                      },
                      model: {
                        value: _vm.form.endDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "endDate", $$v)
                        },
                        expression: "form.endDate",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "task-field" },
                  [
                    _c("label", { staticClass: "task-label" }, [
                      _vm._v(_vm._s(_vm.$t("task.priority"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticClass: "task-input",
                        attrs: {
                          dropdownClassName: "task-priority-select-dropdown",
                        },
                        model: {
                          value: _vm.form.priority,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "priority", $$v)
                          },
                          expression: "form.priority",
                        },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "low" } }, [
                          _c(
                            "div",
                            { staticClass: "priority-option" },
                            [
                              _c("LowIcon", { staticClass: "priority-icon" }),
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$t("message.low")) +
                                  "\n                                "
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "lowest" } }, [
                          _c(
                            "div",
                            { staticClass: "priority-option" },
                            [
                              _c("LowestIcon", {
                                staticClass: "priority-icon",
                              }),
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$t("message.lowest")) +
                                  "\n                                "
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "medium" } }, [
                          _c(
                            "div",
                            { staticClass: "priority-option" },
                            [
                              _c("MediumIcon", {
                                staticClass: "priority-icon",
                              }),
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$t("message.medium")) +
                                  "\n                                "
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "high" } }, [
                          _c(
                            "div",
                            { staticClass: "priority-option" },
                            [
                              _c("HighIcon", { staticClass: "priority-icon" }),
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$t("message.high")) +
                                  "\n                                "
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "highest" } }, [
                          _c(
                            "div",
                            { staticClass: "priority-option" },
                            [
                              _c("HighestIcon", {
                                staticClass: "priority-icon",
                              }),
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$t("message.highest")) +
                                  "\n                                "
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "task-section" }, [
                _c(
                  "div",
                  { staticClass: "task-field" },
                  [
                    _c("label", { staticClass: "task-label" }, [
                      _vm._v(_vm._s(_vm.$t("task.owner"))),
                    ]),
                    _vm._v(" "),
                    _c("a-select", {
                      staticClass: "task-input",
                      attrs: {
                        options: _vm.visibilityUsers,
                        placeholder: _vm.$t("task.owner"),
                        showSearch: "",
                        "filter-option": _vm.filterOption,
                      },
                      model: {
                        value: _vm.form.owner,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "owner", $$v)
                        },
                        expression: "form.owner",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "task-field" },
                  [
                    _c("label", { staticClass: "task-label" }, [
                      _vm._v(_vm._s(_vm.$t("task.assignee"))),
                    ]),
                    _vm._v(" "),
                    _c("a-select", {
                      staticClass: "task-input",
                      attrs: {
                        mode: "multiple",
                        placeholder: _vm.$t("task.selectAssginee"),
                        "max-tag-count": _vm.maxTagCount,
                        options: _vm.visibilityUsers,
                        "filter-option": _vm.filterOption,
                      },
                      model: {
                        value: _vm.form.assignees,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "assignees", $$v)
                        },
                        expression: "form.assignees",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "task-field" },
                  [
                    _c("label", { staticClass: "task-label" }, [
                      _vm._v(_vm._s(_vm.$t("message.follower"))),
                    ]),
                    _vm._v(" "),
                    _c("a-select", {
                      staticClass: "task-input",
                      attrs: {
                        mode: "multiple",
                        placeholder: _vm.$t("task.filterBar.tabFollowers"),
                        "max-tag-count": _vm.maxTagCount,
                        options: _vm.visibilityUsers,
                        "filter-option": _vm.filterOption,
                      },
                      model: {
                        value: _vm.form.followers,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "followers", $$v)
                        },
                        expression: "form.followers",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "task-section" }, [
                _c("div", { staticClass: "task-field-row" }, [
                  _c("label", { staticClass: "task-label" }, [
                    _vm._v(_vm._s(_vm.$t("task.taskID"))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "task-value" }, [
                    _vm._v(_vm._s(_vm.form._id)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.usersMap[_vm.form.createdBy.user] || _vm.form.createdBy.type
                ? _c("div", { staticClass: "task-section" }, [
                    _c("label", { staticClass: "task-section-title" }, [
                      _vm._v(_vm._s(_vm.$t("message.taskCreator"))),
                    ]),
                    _vm._v(" "),
                    _vm.usersMap[_vm.form.createdBy.user]
                      ? _c(
                          "div",
                          { staticClass: "task-creator-card" },
                          [
                            _c("Avatar", {
                              attrs: {
                                size: 32,
                                src: _vm.usersMap[_vm.form.createdBy.user]
                                  .gravatar,
                                username:
                                  _vm.usersMap[_vm.form.createdBy.user].name,
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "task-creator-info" }, [
                              _c("div", { staticClass: "task-creator-name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.usersMap[_vm.form.createdBy.user]
                                      .name || _vm.$t("auto.unknownUser")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "task-creator-date" }, [
                                _vm._v(_vm._s(_vm.formattedCreatedAt)),
                              ]),
                            ]),
                          ],
                          1
                        )
                      : _vm.form.createdBy.type === "api"
                      ? _c(
                          "div",
                          { staticClass: "task-creator-card" },
                          [
                            _c("Avatar", {
                              attrs: {
                                size: 32,
                                src: "https://static.supsis.live/common/email/supsisyazisislogo.png",
                                username: _vm.$t("task.creatorApi"),
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "task-creator-info" }, [
                              _c("div", { staticClass: "task-creator-name" }, [
                                _vm._v(_vm._s(_vm.$t("task.creatorApi"))),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "task-creator-date" }, [
                                _vm._v(_vm._s(_vm.formattedCreatedAt)),
                              ]),
                            ]),
                          ],
                          1
                        )
                      : _vm.form.createdBy.type === "chatbot"
                      ? _c(
                          "div",
                          { staticClass: "task-creator-card" },
                          [
                            _c("Avatar", {
                              attrs: {
                                size: 32,
                                src: "https://static.supsis.live/common/email/supsisyazisislogo.png",
                                username: _vm.$t("auto.chatbot"),
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "task-creator-info" }, [
                              _c("div", { staticClass: "task-creator-name" }, [
                                _vm._v(_vm._s(_vm.$t("auto.chatbot"))),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "task-creator-date" }, [
                                _vm._v(_vm._s(_vm.formattedCreatedAt)),
                              ]),
                            ]),
                          ],
                          1
                        )
                      : _vm.form.createdBy.type === "automation"
                      ? _c(
                          "div",
                          { staticClass: "task-creator-card" },
                          [
                            _c("Avatar", {
                              attrs: {
                                size: 32,
                                src: "https://static.supsis.live/common/email/supsisyazisislogo.png",
                                username: _vm.$t("task.creatorAutomation"),
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "task-creator-info" }, [
                              _c("div", { staticClass: "task-creator-name" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("task.creatorAutomation"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "task-creator-date" }, [
                                _vm._v(_vm._s(_vm.formattedCreatedAt)),
                              ]),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.tableRecords.length > 0
                ? _c(
                    "div",
                    { staticClass: "task-section" },
                    [
                      _c("label", { staticClass: "task-section-title" }, [
                        _vm._v(_vm._s(_vm.$t("task.relatedTableRecords"))),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.tableRecords, function (record, index) {
                        return _c(
                          "div",
                          {
                            key: record._id,
                            staticClass: "task-related-item",
                            on: {
                              click: function ($event) {
                                return _vm.viewRecord(record)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "material-icons task-related-icon",
                              },
                              [_vm._v("table_view")]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "task-related-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("task.tableRecordItem", {
                                    order: index + 1,
                                    tableName: _vm.getTableName(record),
                                  })
                                )
                              ),
                            ]),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "task-section" }, [
                _c("label", { staticClass: "task-section-title" }, [
                  _vm._v(_vm._s(_vm.$t("auto.relatedVisitor"))),
                ]),
                _vm._v(" "),
                _vm.visitorRelation
                  ? _c("div", { staticClass: "task-visitor-card" }, [
                      _c(
                        "div",
                        {
                          staticClass: "task-visitor-info",
                          on: { click: _vm.visitorDetail },
                        },
                        [
                          _c("Avatar", {
                            attrs: {
                              size: 32,
                              src: _vm.visitorRelation.visitor.gravatar,
                              username: _vm.visitorRelation.visitor.fullname,
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "task-visitor-name" }, [
                            _vm._v(
                              _vm._s(_vm.visitorRelation.visitor.fullname)
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "task-visitor-remove material-icons",
                          on: { click: _vm.removeVisitor },
                        },
                        [_vm._v("close")]
                      ),
                    ])
                  : _c(
                      "div",
                      {
                        staticClass: "task-add-visitor",
                        on: { click: _vm.addVisitor },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("add"),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.$t("auto.addVisitor")))]),
                      ]
                    ),
                _vm._v(" "),
                _vm.showModal
                  ? _c(
                      "div",
                      {
                        staticClass: "custom-visitor-modal",
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k($event.keyCode, "esc", 27, $event.key, [
                                "Esc",
                                "Escape",
                              ])
                            ) {
                              return null
                            }
                            return _vm.closeModal.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("div", {
                          staticClass: "custom-visitor-modal-backdrop",
                          on: { click: _vm.closeModal },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "custom-visitor-modal-dialog" },
                          [
                            _c(
                              "div",
                              { staticClass: "custom-visitor-modal-header" },
                              [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("task.selectPerson"))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "material-icons close-icon",
                                    on: { click: _vm.closeModal },
                                  },
                                  [_vm._v("close")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "custom-visitor-modal-body" },
                              [
                                _c("List", {
                                  attrs: { "picker-mode": "" },
                                  on: { select: _vm.handleVisitorSelect },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "custom-visitor-modal-footer" },
                              [
                                _c(
                                  "a-button",
                                  { on: { click: _vm.closeModal } },
                                  [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.closeModal },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("message.save")))]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.getUserIds(_vm.form).length > 0
                ? _c("div", { staticClass: "task-section" }, [
                    _c("label", { staticClass: "task-section-title" }, [
                      _vm._v(_vm._s(_vm.$t("task.assignees"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "task-people-list" },
                      _vm._l(_vm.getUserIds(_vm.form), function (userId) {
                        return _c(
                          "div",
                          { key: userId, staticClass: "task-people-item" },
                          [
                            _c("Avatar", {
                              attrs: {
                                size: 28,
                                src:
                                  _vm.usersMap[userId] &&
                                  _vm.usersMap[userId].gravatar,
                                username:
                                  _vm.usersMap[userId] &&
                                  _vm.usersMap[userId].name,
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "task-people-name" }, [
                              _vm._v(
                                _vm._s(
                                  (_vm.usersMap[userId] &&
                                    _vm.usersMap[userId].name) ||
                                    _vm.$t("auto.unknownUser")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            userId._id !== _vm.loggedUser._id
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "task-people-action material-icons",
                                    on: {
                                      click: function ($event) {
                                        return _vm.startDM(
                                          _vm.usersMap[userId]._id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                mail_outline\n                            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.getUserIdsOwner(_vm.form).length > 0
                ? _c("div", { staticClass: "task-section" }, [
                    _c("label", { staticClass: "task-section-title" }, [
                      _vm._v(_vm._s(_vm.$t("task.owner"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "task-people-list" },
                      _vm._l(_vm.getUserIdsOwner(_vm.form), function (userId) {
                        return _c(
                          "div",
                          { key: userId, staticClass: "task-people-item" },
                          [
                            _c("Avatar", {
                              attrs: {
                                size: 28,
                                src:
                                  _vm.usersMap[userId] &&
                                  _vm.usersMap[userId].gravatar,
                                username:
                                  _vm.usersMap[userId] &&
                                  _vm.usersMap[userId].name,
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "task-people-name" }, [
                              _vm._v(
                                _vm._s(
                                  (_vm.usersMap[userId] &&
                                    _vm.usersMap[userId].name) ||
                                    _vm.$t("auto.unknownUser")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            userId._id !== _vm.loggedUser._id
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "task-people-action material-icons",
                                    on: {
                                      click: function ($event) {
                                        return _vm.startDM(
                                          _vm.usersMap[userId]._id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                mail_outline\n                            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loader-spinner" }, [
      _c("div", { staticClass: "spinner-ring" }),
      _vm._v(" "),
      _c("div", { staticClass: "spinner-ring" }),
      _vm._v(" "),
      _c("div", { staticClass: "spinner-ring" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "file-icon" }, [
      _c("span", { staticClass: "md-icon" }, [_vm._v("insert_drive_file")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }